import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function CashoutHistoryButton() {
	const { t } = useTranslation("mybets");

	const bet = useContext(MyBetsBetContext);
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		console.error("Expected Store, got null.");
		return null;
	}

	return (
		<button
			type="button"
			className="card--bet__btn card--bet__btn--history btn btn--sml btn--primary--subtle"
			onClick={() =>
				store.cashoutStore.fetchCashoutHistoryForBetSlip(bet)
			}
		>
			{t("ITEM.CASHOUT_HISTORY")}
		</button>
	);
});
